import { createAction } from '@reduxjs/toolkit';
import { InsuranceListReq } from 'intakeOptimization/@types';

import { preferencesActions } from './reducers';
import t from './types';

export const {
  updatePreferences,
  updateInsuranceList,
  resetFilters,
  setValidZipCode,
  setHasZipCode,
  setIsBookingModalOpenObie,
  setErrors,
  setExistingUser,
  setColdUser,
  setAccountHolder,
  setLicenseKey,
  setLoading,
  removeClinicianProfileBack,
  setMarketingReferral,
  setPreviousPreferences,
  setMarketingReferralListOptions,
  setCreditCardInfo,
  setSkippedCreditCardInfo,
  resetPreferences,
  setMarketingReferralPhone,
  setLoadingCountByZip,
  setCliniciansAvailableOnZipCode,
} = preferencesActions;
export const validateZipCode = createAction<number | string>(t.VALIDATE_ZIPCODE);
export const fetchValidZipCode = createAction<number | string>(t.FETCH_ZIP_CODE);
export const getInsuranceList = createAction<InsuranceListReq>(t.GET_INSURANCE_LIST);
export const getCliniciansByZipCode = createAction<string>(t.GET_CLINICIANS_COUNT);
export const getCliniciansValidate = createAction<string>(t.GET_CLINICIANS_VALID);
